import { ANIMATION_IDENTIFIERS, DrawAnimationMechanicConfig } from '@Animation/types'
import { PLUS_3_CONFIG } from '../add-on-extra-draw/plus-3/config'
import { MI_MULTIPLIER_CORNHOLE_CONFIG } from '../add-on-multiplier/michigan-kicker/cornhole/config'
import { preLoadAssets, NeonLightsNumber, NeonLightsForeground, NeonLightsNumberSelector } from '.'
import { NeonLightsTexturePreloader } from './texture-loader'
import { NoBackground } from '../base/background'

export const NeonLightsConfig: DrawAnimationMechanicConfig = {
  appSettings: {
    backgroundBaseColor: '#1C1B1BFF',
    backgroundGlowColor: '#745B48FF',
    backgroundUrl: '/animations/neon-lights/background.png',
  },
  numberSelector: NeonLightsNumberSelector,
  background: NoBackground,
  foreground: NeonLightsForeground,
  kenoNumber: NeonLightsNumber,
  multiplierAnimationConfig: MI_MULTIPLIER_CORNHOLE_CONFIG,
  assetPreloader: preLoadAssets,
  extraDrawAnimationConfig: PLUS_3_CONFIG(ANIMATION_IDENTIFIERS.NEON_LIGHTS),
  textureLoader: NeonLightsTexturePreloader,
}
